import { lazy } from 'react';

export const AdvancedPlayerSearchForm = lazy(
  () => import('./AdvancedPlayerSearchForm'),
);
